export default function initializeExternalLinks() {
   const links = document.querySelectorAll('a[data-type="link"]');
   const currentHostname = window.location.hostname;

   links.forEach(link => {
      try {
         const url = new URL(link.href);
         if (url.hostname && url.hostname !== currentHostname) {
            link.classList.add('is-external');
         }
      } catch (e) {
         // Ignorujemy niepoprawne linki
      }
   });
}
